import React, { Component } from 'react'
import Chat from '../../components/chat'
import FeedNews from '../../components/feednews';
import Banner from '../../components/Banner/Banner';
import './index.style.css'
// import { Row, Col, Container } from 'reactstrap';
import { Row, Col } from "antd";

export default function Home() {
  // constructor(props) {
  //   console.log('Page/Home')
  //   super(props);
  // }

 
    return (
      <div className='main-container '>
          <div className='banner-div'>
            <Banner />
          </div>

          <div className='chat-div'>
            <Row 
                justify="center" 
                gutter={[{ xs: 8, sm: 8, md: 10, lg: 12, xl: 24, xxl:24 },8]}
            >
              <Col className="feednews-container"
               xs={{ span: 24, offset: 0, order: 2 }} sm={{ span: 24, order: 2 }} md={{ span: 24, order: 2 }} lg={{ span: 24, order: 1 }} xl={{ span: 12, order: 1 }} xxl={{ span: 12, order: 1 }}>
                <FeedNews />
              </Col >
              <Col className="chat-container" xs={{ span: 24, offset: 0, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }} lg={{ span: 24, order: 2 }} xl={{ span: 12, order: 2 }} xxl={{ span: 12, order: 2 }}>
                <Chat />
              </Col>
            </Row>
          </div>

      </div>
    )
  
}
